<template>
  <div
    class="error-checklist-question"
    :class="{error:error}"
    @click="onClick()"
  >
    <div class="error-checklist-question_left">
      <p class="question-title no-wrap">
        {{ quesNum }}
      </p>
      <p class="question-title">
        {{ title }}
      </p>
    </div>
    <div class="error-checklist-question_right">
      <p class="error-checklist-question_right-text">
        {{ errorText }}
      </p>
      <i
        class="error-checklist-question_right-icon"
        :class="errorIcon"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "ErrorChecklistQuestion",
  props: {
    error: {
      type: Boolean,
      default: false,
    },
    quesNum: {
      type: [Number, String],
    },
    title: {
      type: String,
      default: "",
    },
    errorText: {
      type: String,
      default() {
        return this.$t("未答題");
      },
    },
    errorIcon: {
      type: String,
      default: "icon-arrow-right",
    },
  },
  methods: {
    onClick() {
      this.$emit("error-click");
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/error-checklist-question";
</style>